import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import './Account.css';

const menuItems = [
  { title: 'My Profile',          emoji: '👤', bg: '#e0f2fe', color: '#0284c7', path: '/create-profile' },
  { title: 'My Business',         emoji: '💼', bg: '#fef9c3', color: '#b45309', path: '/my-business' },
  { title: 'Add Business',        emoji: '🏬', bg: '#ede9fe', color: '#7c3aed', path: '/add-business' },
  { title: 'Digital Poster',      emoji: '🖨️', bg: '#dcfce7', color: '#16a34a', path: 'digital-poster-popup' },
  { title: 'Human Resource',      emoji: '👥', bg: '#e0f2fe', color: '#0369a1', path: 'hr-popup' },
  { title: 'Visiting Card',       emoji: '🪪', bg: '#fce7f3', color: '#be185d', path: '/visiting-card' },
  { title: 'Business Certificate',emoji: '⚙️', bg: '#fef3c7', color: '#d97706', path: null },
  { title: 'Offers',              emoji: '🎁', bg: '#fce7f3', color: '#db2777', path: '/offers' },
  { title: 'Referral Code',       emoji: '🤝', bg: '#fef9c3', color: '#ca8a04', path: '/refer' },
  { title: 'Adset Notifications', emoji: '🔔', bg: '#ede9fe', color: '#7c3aed', path: '/adset-notifications', badge: 0 },
  { title: 'Redeem',              emoji: '💲', bg: '#dcfce7', color: '#15803d', path: null },
  { title: 'Redeem Record',       emoji: '📋', bg: '#e0f2fe', color: '#0369a1', path: null },
  { title: 'Share App',           emoji: '↗️', bg: '#fce7f3', color: '#db2777', path: null },
  { title: 'Help Center',         emoji: '❓', bg: '#e0f2fe', color: '#0284c7', path: null },
  { title: 'Support',             emoji: '💬', bg: '#dcfce7', color: '#16a34a', path: 'support-popup' },
  { title: 'Logout',              emoji: '↪️', bg: '#fee2e2', color: '#dc2626', path: 'logout' },
];

const posterCategories = [
  { name: 'Festival',      emoji: '🎉', colors: ['#43A047','#66BB6A'] },
  { name: 'Motivational',  emoji: '💪', colors: ['#E53935','#EF9A9A'] },
  { name: 'Social Worker', emoji: '🤝', colors: ['#1E88E5','#90CAF9'] },
  { name: 'Trending',      emoji: '🔥', colors: ['#8E24AA','#CE93D8'] },
  { name: 'Greetings',     emoji: '🎊', colors: ['#00ACC1','#80DEEA'] },
  { name: 'Suvichar',      emoji: '🧘', colors: ['#F57C00','#FFCC80'] },
];

export default function Account() {
  const navigate = useNavigate();
  const { user, isLoggedIn, logout } = useAuth();
  const [profile, setProfile] = useState(null);
  const [showPosterPopup, setShowPosterPopup] = useState(false);

  useEffect(() => {
    if (isLoggedIn) {
      import('../../utils/api').then(({ default: api }) => {
        api.get('/api/users/profile').then(res => setProfile(res.data.data)).catch(() => {});
      });
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) { navigate('/login'); return null; }

  const handleClick = (item) => {
    if (item.path === 'logout') {
      if (!window.confirm('Are you sure you want to logout?')) return;
      logout();
      toast.success('Logged out successfully!');
      navigate('/login');
    }
    else if (item.path === 'digital-poster-popup') setShowPosterPopup(true);
    else if (item.path === 'hr-popup') window.open('https://justhiring24.com/', '_blank');
    else if (item.path === 'support-popup') window.dispatchEvent(new Event('open-support'));
    else if (item.path) navigate(item.path);
    else alert('Coming Soon!');
  };

  const handleSupportSubmit = async (e) => {
    e.preventDefault();
    try {
      const { default: api } = await import('../../utils/api');
      await api.post('/api/support', { title: spTitle, desc: spMsg, userType: spUser });
      setSpDone(true);
      setSpUser(''); setSpTitle(''); setSpMsg('');
      setTimeout(() => { setSpDone(false); setShowSupportPopup(false); }, 2000);
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to submit. Please try again.');
    }
  };

  const mainItems = menuItems.slice(0, 12);
  const bottomItems = menuItems.slice(12);

  return (
    <div className="account-page">
      <div className="container">
        <div className="account-main-card">
          <div className="account-header">
            <div className="account-profile-card">
              <div className="account-avatar-wrap" onClick={() => navigate('/create-profile')}>
                {profile?.avatar
                  ? <img src={`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/${profile.avatar}`} alt="avatar" className="account-avatar-img" />
                  : <div className="account-avatar-initials">{(profile?.name || user?.name || 'U').charAt(0).toUpperCase()}</div>
                }
              </div>
              <div className="account-profile-info">
                <h2>{profile?.name || user?.name || 'Your Name'}</h2>
                <p>{profile?.occupation || 'Add your occupation'}</p>
                <p className="account-profile-phone">📱 {profile?.phone || user?.phone || ''}</p>
              </div>
              <button className="account-edit-btn" onClick={() => navigate('/create-profile')}>✏️ Edit</button>
            </div>
          </div>
          <div className="account-menu-grid">
            {mainItems.map((item, i) => (
              <div key={i} className="account-menu-item" onClick={() => handleClick(item)}>
                <div className="account-menu-icon" style={{ background: item.bg, color: item.color }}>
                  <span>{item.emoji}</span>
                  {item.badge !== undefined && <span className="menu-badge">{item.badge}</span>}
                </div>
                <span className="account-menu-label">{item.title}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="account-bottom-card">
          <div className="account-bottom-grid">
            {bottomItems.map((item, i) => (
              <div key={i} className="account-menu-item" onClick={() => handleClick(item)}>
                <div className="account-menu-icon" style={{ background: item.bg, color: item.color }}>
                  <span>{item.emoji}</span>
                </div>
                <span className="account-menu-label">{item.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Digital Poster Profile Popup */}
      {showPosterPopup && (
        <div className="modal-overlay" onClick={() => setShowPosterPopup(false)}>
          <div className="account-poster-popup" onClick={e => e.stopPropagation()}>
            <button className="account-poster-popup-close" onClick={() => setShowPosterPopup(false)}>✕</button>
            <h3>Complete Your Profile</h3>
            <p>Click <b>Edit Profile</b> to update your photo,<br />occupation, and address.<br />Once done, click <b>Make Design</b>.</p>
            <div className="account-poster-popup-btns">
              <button className="app-btn edit" onClick={() => { setShowPosterPopup(false); navigate('/create-profile'); }}>Edit Profile</button>
              <button className="app-btn make" onClick={() => { setShowPosterPopup(false); navigate('/digital-poster'); }}>Make Design</button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
}
